module.exports = __webpack_public_path__ + "img/u1981.42c84963.svg";